import { MEDIA_SIZE_LIST } from 'libs/const';
import styled from 'styled-components';

const Container = styled.div`
  background: linear-gradient(45deg, #1c4262, #222c2b);
  box-shadow: 0em 0em 0.15em 0.1em #313438;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.theme.skyw.grayTextColor};
  border-radius: 6px;
  margin-right: 12px;

  @media screen and (max-width: ${`${MEDIA_SIZE_LIST[0]}px`}) {
    font-size: 10px;
    padding: 2px 4px;
  }
`;

interface UpdateLabelProps {
  children: React.ReactNode;
}

const UpdateLabel = ({ children }: UpdateLabelProps) => {
  return <Container>{children}</Container>;
};

export default UpdateLabel;
